// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/ComponentsCss/AdminPanel/ReportsComponent/LeaveReport.css */

.leave-report-container {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  padding: 25px;
  background-color: #f8f9fa; /* Lighter background */
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08); /* Softer shadow */
  max-width: 950px; /* Slightly wider */

  position: relative;
  height: 100%;
  overflow: scroll;
}

.report-header {
  display: flex;
  justify-content:flex-start;
  align-items: center;
  margin-bottom: 5px;
  padding-bottom: 7px;
  border-bottom: 1px solid #e0e0e0; /* Lighter border */
}

.report-header h2 {
  margin: 0;
  color: #343a40; /* Darker text for contrast */
  font-size: 24px;
  font-weight: bold;
  width: 100%;
}

.close-button {
  background-color: #28a745; /* Bootstrap green */
  color: white;
  border: none;
  border-radius: 50%;
  width: 40px; /* Slightly larger */
  height: 40px;
  font-size: 24px; /* Larger icon */
  font-weight: bold;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  transition: background-color 0.3s ease, transform 0.2s ease;
}

.close-button:hover {
  background-color: #218838; /* Darker green on hover */
  transform: scale(1.05);
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr; /* Two columns */
  gap: 5px 100px;
  margin-bottom: 10px;
}

.form_group_report {
  display: flex;
  flex-direction: row;
}

.form_group_report label {
  font-weight: 500; /* Medium font weight */
  margin-bottom: 8px;
  color: #495057; /* Slightly softer black */
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 12px;
  width: 6rem;
}

/* For the red asterisk based on the screenshot */
.form_group_report:nth-child(1) label::after, /* From Date */
  .form_group_report:nth-child(2) label::after {
  /* To Date */
  content: "*";
  color: red;
  margin-right: 4px;
}

.form_group_report input[type="text"],
.form_group_report input[type="date"],
.form_group_report select {
  width: 100%;
  padding: 10px 12px; /* Slightly more padding */
  border: 1px solid #ced4da; /* Lighter border color */
  border-radius: 5px; /* Slightly more rounded corners */
  font-size: 15px;
  box-sizing: border-box;
  background-color: white;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.form_group_report input[type="text"]:focus,
.form_group_report input[type="date"]:focus,
.form_group_report select:focus {
  border-color: #80bdff; /* Blue focus border */
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25); /* Blue focus shadow */
  outline: none; /* Remove default outline */
}

.input-with-icon {
  position: relative;
  width: 100%;
}

.input-with-icon input[type="date"] {
  padding-right: 10px; /* Space for the icon */
  cursor: pointer;
}

/* .calendar-icon {
    position: absolute;
    right: 2px; 
    top: 50%;
    transform: translateY(-50%);
        color: #6c757d;
    cursor: pointer;
    font-size: 22px;
  } */
.report-actions {
  display: flex;
  justify-content: flex-end;
  /* gap: 20px;  */
  /* padding-top: 10px; */
  border-top: 1px solid #e0e0e0;
}

.export-button {
  padding: 9px 21px;
  border: none;
  border-radius: 6px;
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease,
    box-shadow 0.2s ease;
  font-weight: 500;
}

.view_button {
  /* background-color: #28a745; Green */
  margin-top: 10px;
}

.export-button {
  background-color: #007bff; /* Blue */
  color: white;
}

.export-button:hover {
  background-color: #0069d9;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 123, 255, 0.2);
}

/* Floating Close Button at bottom right */
.floating-close-container {
  position: fixed;
  bottom: 25px; /* Slightly more space from bottom */
  right: 25px; /* Slightly more space from right */
  z-index: 1000;
}

.floating-close-button {
  background-color: #28a745; /* Green */
  color: white;
  border: none;
  border-radius: 30px; /* More rounded, pill shape */
  padding: 12px 25px; /* More padding */
  font-size: 17px;
  display: flex;
  align-items: center;
  gap: 10px; /* More space between text and icon */
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25); /* Stronger shadow */
  transition: background-color 0.3s ease, transform 0.2s ease,
    box-shadow 0.2s ease;
}

.floating-close-button:hover {
  background-color: #218838;
  transform: translateY(-3px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
}

.message-icon {
  font-size: 22px; /* Larger icon */
  line-height: 1; /* Align vertically */
}
.form-group input[type="date"],
.form-group select:hover {
  cursor: pointer;
}
.form-group input[type="date"] {
  width: 100%;
  border: 1px solid #ced4da;
  border-radius: 4px;
  margin-top: 0px;
}
.form-group input[type="text"],
.form-group select {
  padding: 10px;
  border: none;
  background-color: white;
  box-sizing: border-box;
  border: 1px solid #ced4da;
  border-radius: 4px;
  margin-top: 0px;

  width: 100%;
}
.form-group {
  margin-bottom: -7px;
  padding: 5px;
  position: relative;
}
/* Responsive adjustments */
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .form-grid {
    grid-template-columns: 1fr; /* Single column on smaller screens */
    gap: 20px;
  }

  .leave-report-container {
    padding: 20px;
    margin: 15px auto;
  }

  .report-header h2 {
    font-size: 22px;
  }

  .close-button {
    width: 35px;
    height: 35px;
    font-size: 20px;
  }

  .export-button {
    width: 100%;
    padding: 12px 20px;
  }

  .floating-close-container {
    bottom: 15px;
    right: 15px;
  }

  .floating-close-button {
    padding: 10px 20px;
    font-size: 16px;
  }
  .form_group_report input[type="text"],
  .form_group_report input[type="date"],
  .form_group_report select {
    width: 100%;
    padding: 10px 12px; /* Slightly more padding */
    border: 1px solid #ced4da; /* Lighter border color */
    border-radius: 5px; /* Slightly more rounded corners */
    font-size: 15px;
    box-sizing: border-box;
    background-color: white;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
  }
}

@media (max-width: 480px) {
  .leave-report-container {
    padding: 15px;
    margin: 10px;
    border-radius: 8px;
  }

  .report-header {
    margin-bottom: 20px;
  }

  .report-header h2 {
    font-size: 20px;
  }

  .form_group_report label {
    font-size: 14px;
  }

  .form_group_report input,
  .form_group_report select {
    padding: 8px 10px;
    font-size: 14px;
  }

  .calendar-icon {
    font-size: 18px;
    right: 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/AdminPanel/ReportsComponent/LeaveReport.css"],"names":[],"mappings":"AAAA,kEAAkE;;AAElE;EACE,4DAA4D;EAC5D,aAAa;EACb,yBAAyB,EAAE,uBAAuB;EAClD,mBAAmB;EACnB,0CAA0C,EAAE,kBAAkB;EAC9D,gBAAgB,EAAE,mBAAmB;;EAErC,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC,EAAE,mBAAmB;AACvD;;AAEA;EACE,SAAS;EACT,cAAc,EAAE,6BAA6B;EAC7C,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,yBAAyB,EAAE,oBAAoB;EAC/C,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW,EAAE,oBAAoB;EACjC,YAAY;EACZ,eAAe,EAAE,gBAAgB;EACjC,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yCAAyC;EACzC,2DAA2D;AAC7D;;AAEA;EACE,yBAAyB,EAAE,0BAA0B;EACrD,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B,EAAE,gBAAgB;EAChD,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB,EAAE,uBAAuB;EACzC,kBAAkB;EAClB,cAAc,EAAE,0BAA0B;EAC1C,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA,iDAAiD;AACjD;;EAEE,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,iBAAiB;AACnB;;AAEA;;;EAGE,WAAW;EACX,kBAAkB,EAAE,0BAA0B;EAC9C,yBAAyB,EAAE,yBAAyB;EACpD,kBAAkB,EAAE,kCAAkC;EACtD,eAAe;EACf,sBAAsB;EACtB,uBAAuB;EACvB,wDAAwD;AAC1D;;AAEA;;;EAGE,qBAAqB,EAAE,sBAAsB;EAC7C,gDAAgD,EAAE,sBAAsB;EACxE,aAAa,EAAE,2BAA2B;AAC5C;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB,EAAE,uBAAuB;EAC5C,eAAe;AACjB;;AAEA;;;;;;;;KAQK;AACL;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf;wBACsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB,EAAE,SAAS;EACpC,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA,0CAA0C;AAC1C;EACE,eAAe;EACf,YAAY,EAAE,oCAAoC;EAClD,WAAW,EAAE,mCAAmC;EAChD,aAAa;AACf;;AAEA;EACE,yBAAyB,EAAE,UAAU;EACrC,YAAY;EACZ,YAAY;EACZ,mBAAmB,EAAE,6BAA6B;EAClD,kBAAkB,EAAE,iBAAiB;EACrC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS,EAAE,qCAAqC;EAChD,eAAe;EACf,0CAA0C,EAAE,oBAAoB;EAChE;wBACsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,eAAe,EAAE,gBAAgB;EACjC,cAAc,EAAE,qBAAqB;AACvC;AACA;;EAEE,eAAe;AACjB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;AACA;;EAEE,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;;EAEf,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;AACA,2BAA2B;AAC3B;EACE;IACE,0BAA0B,EAAE,qCAAqC;IACjE,SAAS;EACX;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;EACA;;;IAGE,WAAW;IACX,kBAAkB,EAAE,0BAA0B;IAC9C,yBAAyB,EAAE,yBAAyB;IACpD,kBAAkB,EAAE,kCAAkC;IACtD,eAAe;IACf,sBAAsB;IACtB,uBAAuB;IACvB,wDAAwD;EAC1D;AACF;;AAEA;EACE;IACE,aAAa;IACb,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,UAAU;EACZ;AACF","sourcesContent":["/* src/ComponentsCss/AdminPanel/ReportsComponent/LeaveReport.css */\n\n.leave-report-container {\n  font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\n  padding: 25px;\n  background-color: #f8f9fa; /* Lighter background */\n  border-radius: 10px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08); /* Softer shadow */\n  max-width: 950px; /* Slightly wider */\n\n  position: relative;\n  height: 100%;\n  overflow: scroll;\n}\n\n.report-header {\n  display: flex;\n  justify-content:flex-start;\n  align-items: center;\n  margin-bottom: 5px;\n  padding-bottom: 7px;\n  border-bottom: 1px solid #e0e0e0; /* Lighter border */\n}\n\n.report-header h2 {\n  margin: 0;\n  color: #343a40; /* Darker text for contrast */\n  font-size: 24px;\n  font-weight: bold;\n  width: 100%;\n}\n\n.close-button {\n  background-color: #28a745; /* Bootstrap green */\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 40px; /* Slightly larger */\n  height: 40px;\n  font-size: 24px; /* Larger icon */\n  font-weight: bold;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\n  transition: background-color 0.3s ease, transform 0.2s ease;\n}\n\n.close-button:hover {\n  background-color: #218838; /* Darker green on hover */\n  transform: scale(1.05);\n}\n\n.form-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr; /* Two columns */\n  gap: 5px 100px;\n  margin-bottom: 10px;\n}\n\n.form_group_report {\n  display: flex;\n  flex-direction: row;\n}\n\n.form_group_report label {\n  font-weight: 500; /* Medium font weight */\n  margin-bottom: 8px;\n  color: #495057; /* Slightly softer black */\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  font-size: 12px;\n  width: 6rem;\n}\n\n/* For the red asterisk based on the screenshot */\n.form_group_report:nth-child(1) label::after, /* From Date */\n  .form_group_report:nth-child(2) label::after {\n  /* To Date */\n  content: \"*\";\n  color: red;\n  margin-right: 4px;\n}\n\n.form_group_report input[type=\"text\"],\n.form_group_report input[type=\"date\"],\n.form_group_report select {\n  width: 100%;\n  padding: 10px 12px; /* Slightly more padding */\n  border: 1px solid #ced4da; /* Lighter border color */\n  border-radius: 5px; /* Slightly more rounded corners */\n  font-size: 15px;\n  box-sizing: border-box;\n  background-color: white;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.form_group_report input[type=\"text\"]:focus,\n.form_group_report input[type=\"date\"]:focus,\n.form_group_report select:focus {\n  border-color: #80bdff; /* Blue focus border */\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25); /* Blue focus shadow */\n  outline: none; /* Remove default outline */\n}\n\n.input-with-icon {\n  position: relative;\n  width: 100%;\n}\n\n.input-with-icon input[type=\"date\"] {\n  padding-right: 10px; /* Space for the icon */\n  cursor: pointer;\n}\n\n/* .calendar-icon {\n    position: absolute;\n    right: 2px; \n    top: 50%;\n    transform: translateY(-50%);\n        color: #6c757d;\n    cursor: pointer;\n    font-size: 22px;\n  } */\n.report-actions {\n  display: flex;\n  justify-content: flex-end;\n  /* gap: 20px;  */\n  /* padding-top: 10px; */\n  border-top: 1px solid #e0e0e0;\n}\n\n.export-button {\n  padding: 9px 21px;\n  border: none;\n  border-radius: 6px;\n  font-size: 12px;\n  cursor: pointer;\n  transition: background-color 0.3s ease, transform 0.2s ease,\n    box-shadow 0.2s ease;\n  font-weight: 500;\n}\n\n.view_button {\n  /* background-color: #28a745; Green */\n  margin-top: 10px;\n}\n\n.export-button {\n  background-color: #007bff; /* Blue */\n  color: white;\n}\n\n.export-button:hover {\n  background-color: #0069d9;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 123, 255, 0.2);\n}\n\n/* Floating Close Button at bottom right */\n.floating-close-container {\n  position: fixed;\n  bottom: 25px; /* Slightly more space from bottom */\n  right: 25px; /* Slightly more space from right */\n  z-index: 1000;\n}\n\n.floating-close-button {\n  background-color: #28a745; /* Green */\n  color: white;\n  border: none;\n  border-radius: 30px; /* More rounded, pill shape */\n  padding: 12px 25px; /* More padding */\n  font-size: 17px;\n  display: flex;\n  align-items: center;\n  gap: 10px; /* More space between text and icon */\n  cursor: pointer;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25); /* Stronger shadow */\n  transition: background-color 0.3s ease, transform 0.2s ease,\n    box-shadow 0.2s ease;\n}\n\n.floating-close-button:hover {\n  background-color: #218838;\n  transform: translateY(-3px);\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);\n}\n\n.message-icon {\n  font-size: 22px; /* Larger icon */\n  line-height: 1; /* Align vertically */\n}\n.form-group input[type=\"date\"],\n.form-group select:hover {\n  cursor: pointer;\n}\n.form-group input[type=\"date\"] {\n  width: 100%;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  margin-top: 0px;\n}\n.form-group input[type=\"text\"],\n.form-group select {\n  padding: 10px;\n  border: none;\n  background-color: white;\n  box-sizing: border-box;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  margin-top: 0px;\n\n  width: 100%;\n}\n.form-group {\n  margin-bottom: -7px;\n  padding: 5px;\n  position: relative;\n}\n/* Responsive adjustments */\n@media screen and (min-width: 768px) and (max-width: 1024px) {\n  .form-grid {\n    grid-template-columns: 1fr; /* Single column on smaller screens */\n    gap: 20px;\n  }\n\n  .leave-report-container {\n    padding: 20px;\n    margin: 15px auto;\n  }\n\n  .report-header h2 {\n    font-size: 22px;\n  }\n\n  .close-button {\n    width: 35px;\n    height: 35px;\n    font-size: 20px;\n  }\n\n  .export-button {\n    width: 100%;\n    padding: 12px 20px;\n  }\n\n  .floating-close-container {\n    bottom: 15px;\n    right: 15px;\n  }\n\n  .floating-close-button {\n    padding: 10px 20px;\n    font-size: 16px;\n  }\n  .form_group_report input[type=\"text\"],\n  .form_group_report input[type=\"date\"],\n  .form_group_report select {\n    width: 100%;\n    padding: 10px 12px; /* Slightly more padding */\n    border: 1px solid #ced4da; /* Lighter border color */\n    border-radius: 5px; /* Slightly more rounded corners */\n    font-size: 15px;\n    box-sizing: border-box;\n    background-color: white;\n    transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  }\n}\n\n@media (max-width: 480px) {\n  .leave-report-container {\n    padding: 15px;\n    margin: 10px;\n    border-radius: 8px;\n  }\n\n  .report-header {\n    margin-bottom: 20px;\n  }\n\n  .report-header h2 {\n    font-size: 20px;\n  }\n\n  .form_group_report label {\n    font-size: 14px;\n  }\n\n  .form_group_report input,\n  .form_group_report select {\n    padding: 8px 10px;\n    font-size: 14px;\n  }\n\n  .calendar-icon {\n    font-size: 18px;\n    right: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
